import { render, staticRenderFns } from "./compOnlinePlayer.vue?vue&type=template&id=7c96e66e&scoped=true"
import script from "./compOnlinePlayer.vue?vue&type=script&lang=js"
export * from "./compOnlinePlayer.vue?vue&type=script&lang=js"
import style0 from "./compOnlinePlayer.vue?vue&type=style&index=0&id=7c96e66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96e66e",
  null
  
)

export default component.exports